import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { I18nModule } from "@spartacus/core";
import { ChannelSelectComponent } from "./channel-select.component";

@NgModule({
  declarations: [ChannelSelectComponent],
  imports: [CommonModule,I18nModule],
  exports: [ChannelSelectComponent],
})

export class ChannelSelectModule {
  
}